module.exports = __webpack_public_path__ + "static/media/Group 10924.dc7c7c55.svg";